import { DownloadIconBlue } from "Icons";
import { FunctionComponent, useState } from "react";
import { saveAs } from "file-saver";
import "./PressImageBox.scss";

type PressImageBoxProps = {
  image?: any;
  title?: string;
  linkName?: string;
  downloadPath?: any;
};

const PressImageBox: FunctionComponent<PressImageBoxProps> = ({
  image,
  title,
  linkName,
  downloadPath,
}) => {
  const [isTouched, setIsTouched] = useState(false);
  const makeLink = (str: string) => {
    let mySubString = str.substring(
      str.lastIndexOf("{%") + 2,
      str.lastIndexOf("%}")
    );
    let deneme = str
      .replace("{%", `<a href=${mySubString} target="_blank">`)
      .replace("%}", "</a>");
    return deneme;
  };
  return (
    <div className="press__image">
      <div className="press__image__image">{image}</div>
      <p
        className="press__image__title"
        dangerouslySetInnerHTML={{
          __html: makeLink(title ?? ""),
        }}
      ></p>
      <a
        onClick={() => {
          saveAs(downloadPath, linkName?.split('.')[0] ?? "");
        }}
        className="press__image__link"
        style={{
          textDecoration: isTouched ? "underline" : "none",
          cursor: "pointer",
        }}
        onMouseOver={() => {
          setIsTouched(true);
        }}
        onMouseLeave={() => {
          setIsTouched(false);
        }}
      >
        <p className="press__image__link__text">{linkName}</p>
        <DownloadIconBlue />
      </a>
    </div>
  );
};

export default PressImageBox;
